import { SourceModel } from './types';
import { GenericState, IState } from '../../../common/store/types';
import { onApiCall } from '../../../common/store/generic.reducer';
import { sourceActions } from './source.action';
import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { ListItem } from '../typeahead/types';

export interface ISourceState extends IState<SourceModel> {
  getById: GenericState<SourceModel>;
  getList: GenericState<ListItem[]>;
  add: GenericState<SourceModel>;
  update: GenericState<SourceModel>;
}

export const sourceInitialState: ISourceState = {
  getById: new GenericState<SourceModel>(),
  getList: new GenericState<ListItem[]>(),
  add: new GenericState<SourceModel>(),
  update: new GenericState<SourceModel>(),
};

const sourceReducers = [
  ...onApiCall<SourceModel>(sourceActions.getById, 'getById'),
  ...onApiCall<ListItem[]>(sourceActions.getList, 'getList'),
  ...onApiCall<SourceModel>(sourceActions.add, 'add'),
  ...onApiCall<SourceModel>(sourceActions.update, 'update'),
];

export const sourceReducer = createReducer(
  sourceInitialState,
  ...sourceReducers,
) as ActionReducer<ISourceState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return sourceReducer(state, action);
}
